module.exports = __webpack_public_path__ + "static/media/lock-icon-outlined.17546bbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/lock-icon-outlined.svg
// module id = 1977
// module chunks = 0